export function degreeToRadian(degree: number): number {
  return degree * 0.017453;
}

export function radianToDegree(radian: number): number {
  return radian * 57.29578;
}
